export default __webpack_public_path__ + "static/media/image-bio.89990e5f.jpg";